import { readCookieValue } from '~/utils/cookie';

export const CONSENT_NOTICE_COOKIE = '__ap_notice_acknowledged';

/** Twelve months in seconds. */
export const CONSENT_NOTICE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export const hasConsentNoticeCookie = (
    cookieHeader?: string | null,
): boolean => {
    if (readCookieValue(cookieHeader, CONSENT_NOTICE_COOKIE) === '1') {
        return true;
    }
    if (typeof document === 'undefined') {
        return false;
    }
    return readCookieValue(document.cookie, CONSENT_NOTICE_COOKIE) === '1';
};

/**
 * Persists the acknowledgement cookie for {@link CONSENT_NOTICE_MAX_AGE_SECONDS}.
 *
 * When `topDomain` is provided we scope the cookie there so the
 * acknowledgement survives subdomain navigation (e.g. `www.` ↔ apex). When
 * it's missing — typical for `localhost` / preview hosts where the browser
 * would reject any `domain=` attribute that doesn't match the origin — we
 * fall back to a host-scoped cookie so the banner still dismisses cleanly.
 */
export const writeConsentNoticeCookie = (topDomain?: string): void => {
    const base = `${CONSENT_NOTICE_COOKIE}=1; path=/; max-age=${CONSENT_NOTICE_MAX_AGE_SECONDS}; SameSite=Lax; Secure`;
    document.cookie = topDomain ? `${base}; domain=${topDomain}` : base;
};
